import React, { useState } from "react";
import {
  JobMatchingFeature,
  CommonAuthFields,
  CommonAuthButton,
  SliderWrapper,
  RuleText,
  PasswordInput,
  EmailInput,
  Link,
} from "../index";
import styles from "./ResetPassword.module.css";
import {
  checkPasswordCase,
  checkPasswordLength,
  checkPasswordSpecialChar,
} from "../utils/passwordUtils";
import { Auth } from "../../../config/aws-exports";
import { useHistory, useLocation } from "react-router-dom";

export const ResetPassword = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = location.state?.email || queryParams.get("email") || "";
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
    code: "",
  });
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.code.length !== 6) {
      setError("Enter valid code.");
      return;
    }
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    } else {
      setLoading(true);
      Auth.forgotPasswordSubmit(email, form.code, form.password)
        .then((data) => {
          setIsSuccess(true);
          setLoading(false);
        })
        .catch((err) => {
          if (
            err?.message ===
              "Invalid verification code provided, please try again." ||
            err?.message ===
              "Invalid code provided, please request a code again."
          ) {
            setError("This verification code didn't work. Try again");
          } else {
            setError(err?.message || "An error occurred. Please try again.");
          }
          setLoading(false);
        });
    }
  };

  return (
    <SliderWrapper>
      {isSuccess ? (
        <div className={styles.card}>
          <h2 className={styles.title}>Successful!</h2>
          <p className={styles.text}>Your password is reset successfully.</p>

          <Link to="/login">
            <CommonAuthButton
              type="button"
              label="Log in"
              className={styles.submitBtn}
              // onClick={handleLoginClick}
            />
          </Link>
        </div>
      ) : (
        <div className={styles.formCard}>
          <h2 className={styles.title}>Reset Password</h2>
          <p className={styles.subTitle}>
            Enter a new password for your account. Make sure it’s strong and
            easy to remember.
          </p>

          <form className={styles.form} onSubmit={handleSubmit}>
            <EmailInput
              required
              type="text"
              maxlength="6"
              label="Enter code"
              name="code"
              value={form.code}
              handleChange={handleChange}
              placeholder="Enter the code sent to your email"
            />
            <PasswordInput
              required
              label="New Password"
              name="password"
              value={form.password}
              handleChange={handleChange}
            />

            <ul className={styles.passRules}>
              <RuleText
                text="At least 8 characters"
                isDone={checkPasswordLength(form.password)}
              />
              <RuleText
                text="One uppercase and one lower case letter"
                isDone={checkPasswordCase(form.password)}
              />
              <RuleText
                text="Contain a number and special character"
                isDone={checkPasswordSpecialChar(form.password)}
              />
            </ul>

            <PasswordInput
              required
              label="Confirm Password"
              name="confirmPassword"
              value={form.confirmPassword}
              handleChange={handleChange}
            />

            {error && <p className={styles.errorText}>{error}</p>}

            <CommonAuthButton
              type="submit"
              label="Reset Password"
              className={styles.submitBtn}
              loading={loading}
              disabled={loading}
            />
          </form>
        </div>
      )}
    </SliderWrapper>
  );
};
